var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectdrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 76,
    viewBox: "0 0 120 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27292",
    "data-name": "Group 27292",
    transform: "translate(-1225 -279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_5328",
    "data-name": "Path 5328",
    transform: "translate(1225 279)",
    fill: "#596267"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112 75 L 8 75 C 4.140183448791504 75 1 71.85981750488281 1 68 L 1 8 C 1 4.140183448791504 4.140183448791504 1 8 1 L 112 1 C 115.8598175048828 1 119 4.140183448791504 119 8 L 119 68 C 119 71.85981750488281 115.8598175048828 75 112 75 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8 2 C 4.691581726074219 2 2 4.691581726074219 2 8 L 2 68 C 2 71.30841827392578 4.691581726074219 74 8 74 L 112 74 C 115.3084182739258 74 118 71.30841827392578 118 68 L 118 8 C 118 4.691581726074219 115.3084182739258 2 112 2 L 8 2 M 8 0 L 112 0 C 116.4182815551758 0 120 3.581718444824219 120 8 L 120 68 C 120 72.41828155517578 116.4182815551758 76 112 76 L 8 76 C 3.581718444824219 76 0 72.41828155517578 0 68 L 0 8 C 0 3.581718444824219 3.581718444824219 0 8 0 Z",
    stroke: "none",
    fill: "#535b61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26338",
    "data-name": "Group 26338",
    transform: "translate(13 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Opacity_State",
    "data-name": "Opacity State",
    transform: "translate(1313 300) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color_",
    "data-name": "Color \\uD83C\\uDFA8",
    d: "M0,1.442A1.439,1.439,0,0,1,2.174.2L14.3,7.4a1.439,1.439,0,0,1,0,2.475l-12.121,7.2A1.439,1.439,0,0,1,0,15.836Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5326",
    "data-name": "Path 5326",
    d: "M49.312,3H7.257A5.272,5.272,0,0,0,2,8.257v36.8a5.272,5.272,0,0,0,5.257,5.257H49.312a5.272,5.272,0,0,0,5.257-5.257V8.257A5.272,5.272,0,0,0,49.312,3ZM23.027,39.8H9.885V34.541H23.027Zm0-10.514H9.885V24.027H23.027Zm0-10.514H9.885V13.514H23.027ZM35.7,34.541l-7.412-7.465L31.99,23.37,35.7,27.1l8.332-8.332L47.761,22.5Z",
    transform: "translate(1230 282)",
    fill: "#d1d1d1",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectdrop);
export default __webpack_public_path__ + "static/media/selectdrop.62df7a2ef7135948920f83070d9b9f3f.svg";
export { ForwardRef as ReactComponent };